import { render, staticRenderFns } from "./detectionReportPreview.vue?vue&type=template&id=63fa5ec8&"
import script from "./detectionReportPreview.vue?vue&type=script&lang=js&"
export * from "./detectionReportPreview.vue?vue&type=script&lang=js&"
import style0 from "./detectionReportPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports